import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { baseCustomerDepartmentReducer, baseCustomerDepartmentEffects } from '../../_store';

@NgModule({
  imports: [
    StoreModule.forFeature('customerDepartment', baseCustomerDepartmentReducer.BaseCustomerDepartmentReducer),
    EffectsModule.forFeature([baseCustomerDepartmentEffects.BaseCustomerDepartmentEffects]),
  ],
})
export class BaseCustomerDepartmentStoreModule {}
